import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) =>
	({
		supportMessageCard: {
			width: "100%",
			padding: theme.spacing(4),
		},
		supportMessageTitle: {
			marginBottom: theme.spacing(2),
			fontWeight: "bold",
		},
		supportMessageText: {
			marginBottom: theme.spacing(2),
			lineHeight: 1.6,
		},
		contactInfo: {
			display: "flex",
			flexDirection: "column",
			gap: theme.spacing(2),
			marginTop: theme.spacing(2),
			padding: theme.spacing(2),
		},
		contactInfoItem: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
		},
		contactIcon: {
			color: "#5F6368",
		},
		clientIdNote: {
			marginTop: theme.spacing(2),
			fontStyle: "italic",
			color: theme.palette.text.secondary,
		},
	} satisfies Record<string, CSSObject>);
